var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260.812,
    height: 36.023,
    viewBox: "0 0 260.812 36.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3009",
    "data-name": "Rectangle 3009",
    width: 260.812,
    height: 36.023,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_166606",
    "data-name": "Group 166606",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49605",
    "data-name": "Path 49605",
    d: "M163.656,23.168h5.427v3.421c1.094-2.372,3.557-3.876,6.84-3.876a11.718,11.718,0,0,1,1.642.136v5.291a11.006,11.006,0,0,0-2.281-.228c-3.785,0-6.2,2.371-6.2,6.157V46.154h-5.427Z",
    transform: "translate(-103.518 -14.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49606",
    "data-name": "Path 49606",
    d: "M202.257,34.346c0-7.388,5.153-12.131,12.04-12.131,6.84,0,11.356,5.154,11.356,11.584,0,0,0,1-.091,1.916H207.684c.183,3.649,2.874,6.019,6.933,6.019a7.925,7.925,0,0,0,6.2-2.645l3.284,3.193a12.441,12.441,0,0,1-9.669,4.1c-7.206,0-12.177-4.652-12.177-11.858Zm17.832-2.462c0-2.736-2.6-5.017-5.792-5.017-3.421,0-6.248,2.235-6.477,5.017Z",
    transform: "translate(-127.934 -14.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49607",
    "data-name": "Path 49607",
    d: "M281.639,8.3c3.877,0,6.567,1.688,7.343,3.831V0h5.472V31.788h-5.472V28.458c-.776,2.143-3.466,3.831-7.343,3.831-6.476,0-11.493-5.2-11.493-12S275.163,8.3,281.639,8.3m.73,19.018a6.886,6.886,0,0,0,7.023-7.024,6.885,6.885,0,0,0-7.023-7.023,6.753,6.753,0,0,0-6.8,7.023,6.754,6.754,0,0,0,6.8,7.024",
    transform: "translate(-170.876 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49608",
    "data-name": "Path 49608",
    d: "M355.112,22.587c3.876,0,6.567,1.688,7.343,3.831v-3.33h5.472V46.075h-5.472V42.745c-.776,2.143-3.467,3.831-7.343,3.831-6.476,0-11.492-5.2-11.492-12s5.017-11.994,11.492-11.994m.73,19.018a7.023,7.023,0,1,0,0-14.047,6.753,6.753,0,0,0-6.8,7.023,6.754,6.754,0,0,0,6.8,7.024",
    transform: "translate(-217.351 -14.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49609",
    "data-name": "Path 49609",
    d: "M429.468,21.967a12.085,12.085,0,0,1,9.212,3.968l-3.375,3.512a7.7,7.7,0,0,0-5.838-2.508,6.966,6.966,0,0,0-7.069,7.206,6.966,6.966,0,0,0,7.069,7.206,7.706,7.706,0,0,0,5.838-2.508l3.375,3.512a12.345,12.345,0,1,1-9.212-20.386",
    transform: "translate(-263.749 -13.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49610",
    "data-name": "Path 49610",
    d: "M490.906,21.967a12.085,12.085,0,0,1,9.212,3.968l-3.375,3.512a7.7,7.7,0,0,0-5.838-2.508,6.966,6.966,0,0,0-7.069,7.206,6.966,6.966,0,0,0,7.069,7.206,7.706,7.706,0,0,0,5.838-2.508l3.375,3.512a12.345,12.345,0,1,1-9.212-20.386",
    transform: "translate(-302.61 -13.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49611",
    "data-name": "Path 49611",
    d: "M539.847,34.346c0-7.388,5.154-12.131,12.04-12.131,6.84,0,11.355,5.154,11.355,11.584,0,0,0,1-.091,1.916H545.274c.183,3.649,2.874,6.019,6.933,6.019a7.924,7.924,0,0,0,6.2-2.645l3.284,3.193a12.441,12.441,0,0,1-9.669,4.1c-7.206,0-12.177-4.652-12.177-11.858Zm17.832-2.462c0-2.736-2.6-5.017-5.792-5.017-3.421,0-6.248,2.235-6.477,5.017Z",
    transform: "translate(-341.471 -14.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49612",
    "data-name": "Path 49612",
    d: "M608.892,38.738a6.971,6.971,0,0,0,6.066,2.874c3.147,0,4.1-1.323,4.1-2.508,0-1.916-2.736-2.372-6.294-3.649-3.374-1.231-5.655-2.965-5.655-6.476,0-4.424,3.74-6.887,8.118-6.887,3.831,0,6.385,1.46,7.981,3.466L620.157,28.8a6.153,6.153,0,0,0-5.017-2.007c-1.733,0-2.781.821-2.781,2.052,0,1.733,1.915,1.961,5.792,3.375,4.242,1.5,6.157,3.511,6.157,6.841,0,3.968-2.873,7.3-9.44,7.3-4.789,0-8.073-1.915-9.486-4.651Z",
    transform: "translate(-382.924 -13.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49613",
    "data-name": "Path 49613",
    d: "M661.762,38.738a6.971,6.971,0,0,0,6.066,2.874c3.147,0,4.1-1.323,4.1-2.508,0-1.916-2.736-2.372-6.294-3.649-3.374-1.231-5.655-2.965-5.655-6.476,0-4.424,3.74-6.887,8.118-6.887,3.831,0,6.385,1.46,7.981,3.466L673.027,28.8a6.153,6.153,0,0,0-5.017-2.007c-1.733,0-2.781.821-2.781,2.052,0,1.733,1.915,1.961,5.792,3.375,4.242,1.5,6.157,3.511,6.157,6.841,0,3.968-2.873,7.3-9.44,7.3-4.789,0-8.073-1.915-9.486-4.651Z",
    transform: "translate(-416.366 -13.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49614",
    "data-name": "Path 49614",
    d: "M8.932,25.84A21.579,21.579,0,0,1,16.308,9.591H16.25a16.25,16.25,0,0,0,0,32.5h.058A21.579,21.579,0,0,1,8.932,25.84",
    transform: "translate(0 -6.066)",
    fill: "#ff002a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49615",
    "data-name": "Path 49615",
    d: "M47.646,14.1a16.251,16.251,0,0,0,0,29.181,16.252,16.252,0,0,0,0-29.181",
    transform: "translate(-24.385 -8.922)",
    fill: "#ff002a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49616",
    "data-name": "Path 49616",
    d: "M55.2,9.3a16.25,16.25,0,1,0,16.25,16.25A16.25,16.25,0,0,0,55.2,9.3M53.9,39.542A13.991,13.991,0,1,1,67.887,25.551,13.991,13.991,0,0,1,53.9,39.542",
    transform: "translate(-24.635 -5.883)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.1ed86c1db924e00133eeb4c6e5074bed.svg";
export { ForwardRef as ReactComponent };